var InformationView = (function (BaseView) {
	return BaseView.extend({
		el: '@information',

		displayRoutes: ['checkout.information'],

		beforeShow: function (opts) {
			BaseView.prototype.beforeShow.apply(this, arguments);
			opts = opts || {};
			this.render(opts.htmlToRender);
		},

		render: function (html) {
			this.$el.html(html);
			return this;
		}
	});
})(BaseView);
